// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import EditLicense from "./components/EditLicense";
import ErrorBoundary from "./components/ErrorBoundary";
import AddUser from "./components/AddUser";
import StrategyActivation from "./components/StrategyActivation";
import ProtectedRoute from "./components/ProtectedRoute";
import { validateToken, isAuthenticated } from "./utils/auth";
import "./App.css";

const AppContent = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );
  const location = useLocation();

  // Validate token on app initialization and route changes
  useEffect(() => {
    // Only validate if user appears to be authenticated
    if (isAuthenticated() && location.pathname !== "/" && location.pathname !== "/strategy-activation") {
      validateToken().then((validation) => {
        if (!validation.valid) {
          // Token is invalid, will be handled by ProtectedRoute or redirect
          console.log("Token validation failed:", validation.message);
        }
      });
    }
  }, [location.pathname]);

  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);
    localStorage.setItem("theme", newMode ? "dark" : "light");
  };

  useEffect(() => {
    // Force dark mode for /strategy-activation, otherwise use user preference
    if (location.pathname === "/strategy-activation") {
      document.body.classList.add("dark-mode");
    } else {
    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
    }
    // Clean up: remove dark mode if leaving the page
    return () => {
      if (location.pathname === "/strategy-activation") {
        document.body.classList.remove("dark-mode");
      }
    };
  }, [isDarkMode, location.pathname]);

  return (
        <div className="app-container">
      {/* Only show toggle if not on /strategy-activation */}
      {location.pathname !== "/strategy-activation" && (
          <div className="theme-toggle">
            <button className="toggle-button" onClick={toggleDarkMode}>
              <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
            </button>
          </div>
      )}
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/strategy-activation" element={<StrategyActivation />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-license"
              element={
                <ProtectedRoute>
                  <EditLicense />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute>
                  <AddUser />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
  );
};

const App = () => (
  <ErrorBoundary>
    <Router>
      <AppContent />
      </Router>
    </ErrorBoundary>
  );

export default App;
